"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectionSearch = void 0;
var keys_1 = require("../../keys");
var utils_1 = require("../../utils/utils");
var element_from_string_1 = require("../../utils/element-from-string");
var listener_1 = require("../../utils/event-listener/listener");
var SelectionSearch = function (target) {
    return /** @class */ (function (_super) {
        __extends(SelectionSearch, _super);
        function SelectionSearch() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        SelectionSearch.prototype.render = function () {
            var search = element_from_string_1.elementFromString('<li class="select2-search select2-search--inline">' +
                '<input class="select2-search__field" type="search" tabindex="-1"' +
                ' autocorrect="off" autocapitalize="none"' +
                ' spellcheck="false" role="searchbox" aria-autocomplete="list" />' +
                '</li>');
            this.searchContainer = search;
            this.search = search.querySelector('input');
            this.search.autocomplete = this.options.get('autocomplete');
            var selectionId = this.core.id + '-container';
            this.search.setAttribute('aria-describedby', selectionId);
            var rendered = _super.prototype.render.call(this);
            this._transferTabIndex();
            // rendered.append(this.searchContainer);
            return rendered;
        };
        SelectionSearch.prototype.binding = function (select, container) {
            var _this = this;
            var resultsId = select.id + '-results';
            _super.prototype.binding.call(this, select, container);
            select.on('open', function () {
                _this.search.setAttribute('aria-controls', resultsId);
                _this.search.focus();
            });
            select.on('close', function () {
                _this.search.value = '';
                _this.resizeSearch();
                _this.search.removeAttribute('aria-controls');
                _this.search.removeAttribute('aria-activedescendant');
                _this.search.focus();
            });
            select.on('enable', function () {
                _this.search.disabled = false;
                _this._transferTabIndex();
            });
            select.on('disable', function () {
                _this.search.disabled = true;
            });
            select.on('focus', function () {
                _this.search.focus();
            });
            select.on('results:focus', function (params) {
                if (params.data._resultId) {
                    _this.search.setAttribute('aria-activedescendant', params.data._resultId);
                }
                else {
                    _this.search.removeAttribute('aria-activedescendant');
                }
            });
            listener_1.createListener({
                elements: this.searchContainer,
                events: 'focusin',
                listeners: this.core.listeners,
                callback: function (evt) {
                    _this.search.focus();
                }
            });
            listener_1.createListener({
                elements: this.searchContainer,
                events: 'focusout',
                listeners: this.core.listeners,
                callback: function (evt) {
                    _this._handleBlur(evt);
                }
            });
            listener_1.createListener({
                elements: this.searchContainer,
                events: 'keydown',
                listeners: this.core.listeners,
                callback: function (evt) {
                    evt.stopPropagation();
                    _this.trigger('keypress', evt);
                    _this._keyUpPrevented = evt.defaultPrevented;
                    var key = evt.which;
                    if (key === keys_1.KEYS.BACKSPACE && _this.search.value === '') {
                        var previousChoice = utils_1.Utils.getLastElement(_this.selection, '.select2-selection__choice');
                        if (!!previousChoice) {
                            var item = utils_1.Utils.GetData(previousChoice, 'data');
                            _this.searchRemoveChoice(item);
                            evt.preventDefault();
                        }
                    }
                }
            });
            listener_1.createListener({
                elements: this.searchContainer,
                events: 'click',
                listeners: this.core.listeners,
                callback: function (evt) {
                    if (_this.search.value) {
                        evt.stopPropagation();
                    }
                }
            });
            // Try to detect the IE version should the `documentMode` property that
            // is stored on the document. This is only implemented in IE and is
            // slightly cleaner than doing a user agent check.
            // This property is not available in Edge, but Edge also doesn't have
            // this bug.
            var msie = document['documentMode'];
            var disableInputEvents = msie && msie <= 11;
            listener_1.createListener({
                elements: this.search,
                events: 'input keyup',
                listeners: this.core.listeners,
                callback: function (event, eventName) {
                    // IE will trigger the `input` event when a placeholder is used on a
                    // search box. To get around this issue, we are forced to ignore all
                    // `input` events in IE and keep using `keyup`.
                    if (disableInputEvents && eventName === 'input') {
                        return;
                    }
                    var key = event.which;
                    // We can freely ignore events from modifier keys
                    if (key === keys_1.KEYS.SHIFT || key === keys_1.KEYS.CTRL || key === keys_1.KEYS.ALT) {
                        return;
                    }
                    // Tabbing will be handled during the `keydown` phase
                    if (key === keys_1.KEYS.TAB) {
                        return;
                    }
                    _this.handleSearch();
                }
            });
        };
        SelectionSearch.prototype._transferTabIndex = function () {
            this.search.setAttribute('tabindex', this.selection.getAttribute('tabindex'));
            this.selection.setAttribute('tabindex', '-1');
        };
        SelectionSearch.prototype.createPlaceholder = function (placeholder) {
            this.search.setAttribute('placeholder', placeholder.text);
        };
        SelectionSearch.prototype.update = function (data) {
            var searchHadFocus = this.search === document.activeElement;
            this.search.setAttribute('placeholder', '');
            _super.prototype.update.call(this, data);
            this.selection
                .querySelector('.select2-selection__rendered')
                .append(this.searchContainer);
            this.resizeSearch();
            if (searchHadFocus) {
                this.search.focus();
            }
        };
        SelectionSearch.prototype.handleSearch = function () {
            this.resizeSearch();
            if (!this._keyUpPrevented) {
                var input = this.search.value;
                this.trigger('query', {
                    term: input
                });
            }
            this._keyUpPrevented = false;
        };
        SelectionSearch.prototype.searchRemoveChoice = function (item) {
            this.trigger('unselect', {
                data: item
            });
            this.search.value = item.text;
            this.handleSearch();
        };
        SelectionSearch.prototype.resizeSearch = function () {
            this.search.style.width = '25px';
            var width = '100%';
            if (this.search.getAttribute('placeholder') === '') {
                var minimumWidth = this.search.value.length + 1;
                width = (minimumWidth * 0.75) + 'em';
            }
            this.search.style.width = width;
        };
        return SelectionSearch;
    }(target));
};
exports.SelectionSearch = SelectionSearch;
//# sourceMappingURL=search.js.map